import { render, staticRenderFns } from "./BaseTextField.vue?vue&type=template&id=0d5ab0b2&scoped=true"
import script from "./BaseTextField.vue?vue&type=script&lang=ts"
export * from "./BaseTextField.vue?vue&type=script&lang=ts"
import style0 from "./BaseTextField.vue?vue&type=style&index=0&id=0d5ab0b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5ab0b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
